/* Shared cart behavior for the Protect Spray and Suede Reviver funnels. */
window.FunnelMiniCartMixin = (Base) => class extends Base {
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: this.currency, currencyDisplay: 'narrowSymbol' }).format(cents / 100); }

    cleanCartText(value) {
      return String(value || '')
        .replace(/\bdefault title\b/gi, '')
        .replace(/\s*\|\s*upc\b.*$/i, '')
        .replace(/\s*\|\s*barcode\b.*$/i, '')
        .replace(/^\s*\|\s*|\s*\|\s*$/g, '')
        .replace(/\s{2,}/g, ' ')
        .trim();
    }

    escapeHtml(value) {
      return String(value || '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));
    }

    async cartRequest(path, body) {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}${path}`, {
        method: body ? 'POST' : 'GET',
        headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        body: body ? JSON.stringify(body) : undefined
      });
      if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
      return response.json();
    }

    async refreshDesktopCart(open = false) {
      if (!this.desktopCart) return;
      try {
        this.realCart = await this.cartRequest('cart.js');
        this.renderDesktopCart();
        this.renderRealCartMobile();
        if (open) {
          if (this.desktopBreakpoint.matches) this.setDesktopCartExpanded(true);
          else this.toggleMiniCart();
        }
      } catch (error) {
        console.error('Protect Spray Funnel cart refresh failed', error);
      }
    }

    async addDesktopVariant(id, quantity = 1, open = true) {
      try {
        await this.cartRequest('cart/add.js', { items: [{ id: Number(id), quantity }] });
        await this.refreshDesktopCart(open);
        return true;
      } catch (error) {
        console.error('Protect Spray Funnel cart add failed', error);
        return false;
      }
    }

    async addDesktopVariants(ids) {
      try {
        await this.cartRequest('cart/add.js', { items: ids.map((id) => ({ id: Number(id), quantity: 1 })) });
        await this.refreshDesktopCart(false);
        return true;
      } catch (error) {
        console.error('Protect Spray Funnel scent add failed', error);
        return false;
      }
    }

    async toggleDesktopProduct(button) {
      const variantId = String(button.dataset.variantId || '');
      const item = this.realCart?.items?.find((line) => String(line.variant_id) === variantId);
      if (item) await this.changeDesktopLine(item.key, 0);
      else await this.addDesktopVariant(variantId, 1, true);
    }

    async changeDesktopLine(key, quantity) {
      try {
        this.realCart = await this.cartRequest('cart/change.js', { id: key, quantity });
        this.renderDesktopCart();
        this.renderRealCartMobile();
        this.setDesktopCartExpanded(true);
      } catch (error) {
        console.error('Protect Spray Funnel cart update failed', error);
      }
    }

    handleDesktopCartAction(event) {
      const action = event.target.closest('[data-real-cart-action]');
      if (!action) return;
      const item = this.realCart?.items?.find((line) => line.key === action.dataset.lineKey);
      if (!item) return;
      const quantity = action.dataset.realCartAction === 'remove' ? 0 : Math.max(0, item.quantity + (action.dataset.realCartAction === 'increase' ? 1 : -1));
      this.changeDesktopLine(item.key, quantity);
    }

    setDesktopCartExpanded(expanded) {
      if (!this.desktopCart) return;
      this.desktopCart.dataset.expanded = String(expanded);
      const toggle = this.querySelector('[data-desktop-cart-toggle]');
      const body = this.querySelector('[data-desktop-cart-body]');
      const collapsed = this.querySelector('[data-desktop-cart-collapsed]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.setAttribute('aria-label', expanded ? 'Hide cart items' : 'View cart items');
        toggle.innerHTML = `${expanded ? 'Hide' : 'View'} items <span aria-hidden="true">${expanded ? '▾' : '▴'}</span>`;
      }
      if (body) body.hidden = !expanded;
      if (collapsed) collapsed.hidden = expanded;
      requestAnimationFrame(() => this.syncStickyClearance?.());
    }

    renderDesktopCart() {
      if (!this.realCart || !this.desktopCartItems) return;
      const { items = [], item_count: count = 0, total_price: total = 0 } = this.realCart;
      this.desktopCartItems.replaceChildren(...items.map((item) => {
        const card = document.createElement('article');
        card.className = 'cp-fmc__desktop-cart-card';
        const title = this.escapeHtml(this.cleanCartText(item.product_title || item.title));
        const variant = this.escapeHtml(this.cleanCartText(item.variant_title));
        const key = this.escapeHtml(item.key);
        const image = this.escapeHtml(item.image);
        card.innerHTML = `<div class="cp-fmc__desktop-cart-thumb">${image ? `<img src="${image}" alt="">` : ''}</div><div class="cp-fmc__desktop-cart-copy"><strong>${title}</strong><span>${variant}</span><div class="cp-fmc__desktop-cart-card-foot"><div class="cp-fmc__desktop-qty"><button type="button" data-real-cart-action="decrease" data-line-key="${key}" aria-label="Decrease ${title}">−</button><span>${item.quantity}</span><button type="button" data-real-cart-action="increase" data-line-key="${key}" aria-label="Increase ${title}">+</button></div><b>${this.money(item.final_line_price)}</b></div></div><button type="button" class="cp-fmc__desktop-remove" data-real-cart-action="remove" data-line-key="${key}" aria-label="Remove ${title}">×</button>`;
        return card;
      }));
      const set = (selector, value) => { const node = this.querySelector(selector); if (node) node.textContent = value; };
      set('[data-desktop-cart-count]', count);
      set('[data-desktop-cart-summary]', `${count} ${count === 1 ? 'item' : 'items'} in your kit`);
      set('[data-desktop-subtotal-label]', `Subtotal · ${count} ${count === 1 ? 'item' : 'items'}`);
      set('[data-desktop-total]', this.money(total));
      const threshold = Number(this.dataset.shippingThreshold || 0);
      const remaining = Math.max(0, threshold - total);
      set('[data-desktop-shipping]', threshold > 0 && remaining === 0 ? this.dataset.shippingUnlocked : this.dataset.shippingCopy.replace('[amount]', this.money(remaining)));
      const progress = this.querySelector('[data-desktop-progress]');
      if (progress) {
        const percent = threshold > 0 ? Math.min(100, total / threshold * 100) : 0;
        progress.style.width = `${percent}%`;
        progress.parentElement?.setAttribute('aria-valuenow', String(Math.round(percent)));
        progress.parentElement?.setAttribute('aria-valuetext', threshold > 0 && remaining === 0 ? this.dataset.shippingUnlocked : this.dataset.shippingCopy.replace('[amount]', this.money(remaining)));
      }
      const stack = this.querySelector('[data-desktop-cart-stack]');
      if (stack) {
        stack.replaceChildren(...items.slice(0, 5).map((item) => {
          const thumb = document.createElement('span');
          thumb.innerHTML = `${item.image ? `<img src="${item.image}" alt="">` : ''}${item.quantity > 1 ? `<b>${item.quantity}</b>` : ''}`;
          return thumb;
        }));
      }
      this.crossSells.forEach((button) => {
        const active = items.some((item) => String(item.variant_id) === String(button.dataset.variantId));
        const toggle = button.querySelector('[data-cross-sell-toggle]') || button;
        toggle.setAttribute('aria-pressed', String(active));
        toggle.setAttribute('aria-label', `${active ? this.dataset.removeLabel || 'Remove' : this.dataset.addLabel || 'Add'} ${button.dataset.lineTitle || 'add-on'}`);
        const label = toggle.querySelector('[data-toggle-label]');
        if (label) label.textContent = active ? this.dataset.removeLabel || 'Remove' : this.dataset.addLabel || '+ Add';
      });
      this.syncDesktopCartArrows();
      requestAnimationFrame(() => this.syncStickyClearance?.());
    }

    syncDesktopCartArrows() {
      if (!this.desktopCartItems) return;
      const max = this.desktopCartItems.scrollWidth - this.desktopCartItems.clientWidth;
      this.desktopCartItems.classList.toggle('has-left-overflow', this.desktopCartItems.scrollLeft > 2);
      this.desktopCartItems.classList.toggle('has-right-overflow', this.desktopCartItems.scrollLeft < max - 2);
      const previous = this.querySelector('[data-cart-scroll="previous"]');
      const next = this.querySelector('[data-cart-scroll="next"]');
      if (previous) previous.disabled = this.desktopCartItems.scrollLeft <= 2;
      if (next) next.disabled = this.desktopCartItems.scrollLeft >= max - 2;
    }

    toggleMiniCart() {
      if (!this.miniCart) return;
      if (!this.miniCart.hidden) {
        this.closeMiniCart();
        return;
      }
      this.miniCart.hidden = false;
      this.cartSummary?.setAttribute('aria-expanded', 'true');
      this.miniCartClose?.focus();
    }

    closeMiniCart() {
      if (!this.miniCart) return;
      this.miniCart.hidden = true;
      this.cartSummary?.setAttribute('aria-expanded', 'false');
    }

    decrementLine(id, type) {
      const line = this.realCart?.items?.find((item) => item.key === id);
      if (line) this.changeDesktopLine(line.key, Math.max(0, line.quantity - 1));
    }

    createCartLine(line) {
        const row = document.createElement('div');
        row.className = 'cp-fmc__mini-cart-line';
        const thumb = document.createElement('div');
        thumb.className = 'cp-fmc__mini-cart-thumb';
        if (line.image) {
          const image = document.createElement('img');
          image.src = line.image;
          image.alt = '';
          image.width = 32;
          image.height = 32;
          thumb.append(image);
        }
        const quantity = document.createElement('span');
        quantity.className = 'cp-fmc__mini-cart-quantity';
        quantity.textContent = `x${line.quantity}`;
        const remove = document.createElement('button');
        remove.className = 'cp-fmc__mini-cart-remove';
        remove.type = 'button';
        remove.dataset.removeLine = line.key || line.id;
        remove.dataset.lineType = 'real';
        remove.setAttribute('aria-label', `${this.dataset.removeLabel || 'Remove'} ${line.title}`);
        remove.textContent = '−';
        thumb.append(quantity);
        thumb.append(remove);
        const copy = document.createElement('div');
        copy.className = 'cp-fmc__mini-cart-copy';
        const displayTitle = [line.title, line.pdpTitle, line.productTitle, line.variantTitle]
          .map((value) => this.cleanCartText(value))
          .find(Boolean);
        const title = document.createElement('span');
        title.className = 'cp-fmc__mini-cart-name';
        title.textContent = displayTitle || '';
        copy.append(title);
        const price = document.createElement('strong');
        price.className = 'cp-fmc__mini-cart-price';
        price.textContent = this.money(line.linePrice ?? line.price * line.quantity);
        row.append(thumb, copy, price);
        return row;
    }

    renderMiniCart(lines) {
      if (!this.miniCartLines) return;
      this.miniCartLines.replaceChildren();
      this.querySelector('[data-mini-cart-empty]').hidden = lines.length > 0;
      lines.forEach((line) => {
        this.miniCartLines.append(this.createCartLine(line));
      });
    }

    renderInlineCart(lines) {
      if (!this.inlineCartLines) return;
      this.inlineCartLines.replaceChildren();
      this.querySelector('[data-inline-cart-empty]').hidden = lines.length > 0;
      lines.forEach((line) => {
        this.inlineCartLines.append(this.createCartLine(line));
      });
    }

    renderRealCartMobile() {
      if (!this.realCart) return;
      const lines = this.realCart.items.map((item) => ({
        id: String(item.variant_id),
        key: item.key,
        title: item.product_title || item.title,
        productTitle: item.product_title,
        variantTitle: item.variant_title,
        image: item.image,
        linePrice: item.final_line_price,
        price: item.final_price,
        quantity: item.quantity
      }));
      const count = this.realCart.item_count || 0;
      const total = this.realCart.total_price || 0;
      const threshold = Number(this.dataset.shippingThreshold || 0);
      const remaining = Math.max(0, threshold - total);
      const shippingText = threshold <= 0 ? '' : remaining === 0 ? this.dataset.shippingUnlocked : this.dataset.shippingCopy.replace('[amount]', this.money(remaining));
      this.renderMiniCart(lines);
      this.renderInlineCart(lines);
      this.querySelector('[data-total]').textContent = this.money(total);
      this.querySelector('[data-item-count]').textContent = `${count} × ${count === 1 ? this.dataset.itemSingular : this.dataset.itemPlural}`;
      this.querySelector('[data-sticky-shipping]').textContent = shippingText;
      const topShipping = this.querySelector('[data-top-shipping]');
      if (topShipping) topShipping.textContent = shippingText;
      this.querySelectorAll('[data-shipping-progress]').forEach((progress) => {
        const percent = threshold > 0 ? Math.min(100, total / threshold * 100) : 0;
        progress.style.width = `${percent}%`;
        progress.parentElement?.setAttribute('aria-valuenow', String(Math.round(percent)));
        progress.parentElement?.setAttribute('aria-valuetext', shippingText);
      });
      const announcement = this.querySelector('[data-cart-announcement]');
      if (announcement) announcement.textContent = `${count} ${count === 1 ? this.dataset.itemSingular : this.dataset.itemPlural}, ${this.money(total)}. ${shippingText}`;
      if (this.checkoutButton) this.checkoutButton.disabled = count === 0;
      if (this.footerAction) this.footerAction.textContent = count > 0 ? this.footerAction.dataset.checkoutLabel : this.footerAction.dataset.chooseLabel;
    }

    async checkout() {
      if ((this.realCart?.item_count || 0) > 0) window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
    }
};
